import { defineAsyncComponent, ref, shallowRef } from 'vue';
import type { CreateReview, ReviewStep } from './types';
import { i18n } from '@/services/i18n';
import { errorHandler, useForm } from '@/services/form';
import { api } from '@/services/api';

const { t } = i18n.global;

export const values = useForm<CreateReview>({
  rating: 0,
  description: '',
  hygiene_rating: null,
  communication_rating: null,
  location_rating: null,
  facility_rating: null,
  consent: false,
});

async function createReview() {
  values.clearErrors();

  try {
    const url = window.location.href;
    const { data } = await api.post<{ redirect_url: string }>(url, values.form.value);
    if (!data) return;

    window.location.href = data.redirect_url;
  } catch (error) {
    values.setErrors(error);
    errorHandler(error);
  }
}
export const currentStep = ref<number>(0);

export function goNext() {
  currentStep.value++;
}

export function goBack() {
  if (currentStep.value === 0) return;
  currentStep.value--;
}

export const steps = shallowRef<ReviewStep[]>([
  {
    step: 0,
    previous: false,
    component: defineAsyncComponent(() => import('@/apps/website/pages/review/steps/0-General.vue')),
    button: t('review.steps.0.button'),
    footer: t('review.steps.0.footer'),
    title: t('review.steps.0.title'),
    description: t('review.steps.0.description'),
  },
  {
    step: 1,
    previous: true,
    component: defineAsyncComponent(() => import('@/apps/website/pages/review/steps/1-Details.vue')),
    button: t('review.steps.1.button'),
    footer: t('review.steps.1.footer'),
    title: t('review.steps.1.title'),
    description: t('review.steps.1.description'),
    submit: createReview,
  },
]);
